// src/components/trades/analysis/RosterCompositionSection.js
import React from 'react';
import { dynastyTheme } from '../../../services/colorService';
import { Users, Plus, Minus } from 'lucide-react';

export const RosterCompositionSection = ({ data }) => {
  if (!data) return null;

  const { proposing_team, receiving_team } = data;

  const renderPositionChanges = (teamData, teamName) => {
    const { before, after, changes } = teamData;
    
    // Filter out 'null' positions (bench/unassigned players) - only show actual position changes
    const positions = Object.keys(changes || {}).filter(pos => pos !== 'null');

    if (positions.length === 0) {
      return (
        <div className="text-gray-500 text-sm">No position changes</div>
      );
    }

    return (
      <div className="space-y-2">
        {positions.map(pos => {
          const change = changes[pos];
          const isPositive = change > 0;
          
          return (
            <div key={pos} className="flex justify-between items-center p-2 bg-gray-800/50 rounded">
              <div className="flex items-center gap-2">
                <span className="font-mono font-semibold text-white w-8">{pos}</span>
                <span className="text-gray-400 text-sm">
                  {before[pos] || 0} → {after[pos] || 0}
                </span>
              </div>
              <span className={`font-mono font-bold flex items-center gap-1 ${isPositive ? 'text-emerald-400' : 'text-red-400'}`}>
                {isPositive ? <Plus className="w-3 h-3" /> : <Minus className="w-3 h-3" />}
                {Math.abs(change)}
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className={`p-4 ${dynastyTheme.classes.bg.darkCard} rounded-lg border ${dynastyTheme.classes.border.neutral}`}>
      <h3 className={`text-lg font-bold ${dynastyTheme.classes.text.primary} mb-4 flex items-center gap-2`}>
        <Users className="w-5 h-5" />
        Roster Composition Changes
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <h4 className="text-lg font-semibold text-white mb-3">Your Team</h4>
          {renderPositionChanges(proposing_team, "Your Team")}
        </div>
        <div>
          <h4 className="text-lg font-semibold text-white mb-3">Their Team</h4>
          {renderPositionChanges(receiving_team, "Their Team")}
        </div>
      </div>
    </div>
  );
};

export default RosterCompositionSection;
